import { useEffect, useState } from 'react';
import { useFragment, graphql } from 'react-relay';
import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';

import { useSoldItemLinksPdpClientVariant_item$key } from './__generated__/useSoldItemLinksPdpClientVariant_item.graphql';

const itemFragment = graphql`
    fragment useSoldItemLinksPdpClientVariant_item on Item {
        isAuctionEnabled
    }
`;

export const useSoldItemLinksPdpClientVariant = ({
    item: itemRef,
}: {
    item: useSoldItemLinksPdpClientVariant_item$key;
}): boolean | null => {
    const { isAuctionEnabled } = useFragment(itemFragment, itemRef);
    const [isSoldItemLinksPdpClient, setIsSoldItemLinksPdpClient] = useState<boolean | null>(null);

    useEffect(() => {
        setIsSoldItemLinksPdpClient(
            getAbTestV2('soldItemLinksPDP')?.variant === 'variant' && !isAuctionEnabled
        );
    }, [isAuctionEnabled]);

    return isSoldItemLinksPdpClient;
};
